import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-payment-receipt-briefly-officer',
  templateUrl: './payment-receipt-briefly-officer.component.html',
  styleUrl: './payment-receipt-briefly-officer.component.scss'
})
export class PaymentReceiptBrieflyOfficerComponent {


 

  constructor(
      private dialogRef: MatDialogRef<PaymentReceiptBrieflyOfficerComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
    ) {
    }
  

    

    advtOfficierbrieflyFormBeans: any = []
    
  
    reportType:any
    startDate :any
    endDate :any
    repName :any
    offRepName:any
    advtName :any
    issueDates:any
    issueDates1:any
  
   PaymentReceiptRegister = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
      rep_name: new FormControl(),
      off_rep_name: new FormControl(),
      issuename: new FormControl(),
      issueDates:new FormControl(),
    });
    startDate_contract: any;
    enddate_contract: any;
    advtOfficierbrieflyTotal :number = 0;
    ngOnInit(): void {
  
  debugger
  let repname: any = this.data['repName'];
  
      // Then check if it's not empty and convert to array
      if (repname != "") {
        repname = repname; // This puts the single value in an array
      }
  
      this.reportType = this.data['reportType'];
      this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
      this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
      this.repName = this.data['repName'];
      this.offRepName = this.data['offRepName'];
      this.advtName = this.data['name'];
      this.issueDates = this.data.issueDates;
      this.issueDates1 = this.data['issue_date'];

  
    const req: any = {
      "rep_name": repname,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "advt_name": this.data['name'],
      // // "issue_name" : this.advtName,
      // "issue_date": this.issueDates
      "issue_name": "",
      "issue_date": this.issueDates
  
  
    }

    // this.service.getAdvtOfficerBriefly1(req).subscribe((data) => {
    //   this.advtOfficierbrieflyFormBeans = data;
    //   // this.OutStandingIDTotal = 0;
    //   // this.OutStandingIDNetAmtTotal = 0;
    //   // this.OutStandingIDUnPaidTotal = 0;
    //   // for (let data of this.advtOfficierbrieflyFormBeans) {
    //   //   for(let data1 of data.rep_data){
    //   //     this.OutStandingIDTotal += parseInt(data1.advt_amt_total) || 0;
    //   //     this.OutStandingIDNetAmtTotal += parseInt(data1.net_amt_total) || 0;
    //   //     this.OutStandingIDUnPaidTotal += parseInt(data1.unpaid_amt_total) || 0;
    //   //   } 
    //   // }
    //   this.advtOfficierbrieflyTotal = 0;

    //   // this.advtOfficierbrieflyTotal = 0;
    //   if (this.advtOfficierbrieflyFormBeans != null) {
    //     for (let data of this.advtOfficierbrieflyFormBeans) {
    //       for (let data1 of data.rep_data) {
    //         this.advtOfficierbrieflyTotal += parseInt(data1.rcv_amt) || 0;

    //       }
    //     }
    //   }
    // });



//     this.service.getAdvtOfficerBriefly1(req).subscribe((data) => {
//     this.advtOfficierbrieflyFormBeans = data;
//     this.advtOfficierbrieflyTotal = 0;

//     if (this.advtOfficierbrieflyFormBeans != null) {
//         // Process each office representative
//         for (let officeRep of this.advtOfficierbrieflyFormBeans) {
//             // Group records by rep_name
//             const repMap = new Map();
            
//             for (let record of officeRep.rep_data) {
//                 const repName = record.rep_name;
                
//                 if (!repMap.has(repName)) {
//                     repMap.set(repName, {
//                         rep_name: repName,
//                         records: [],
//                         rep_total: 0
//                     });
//                 }
                
//                 repMap.get(repName).records.push(record);
//                 repMap.get(repName).rep_total += parseInt(record.rcv_amt) || 0;
                
//                 // Add to grand total
//                 this.advtOfficierbrieflyTotal += parseInt(record.rcv_amt) || 0;
//             }
            
//             // Convert map to array for template
//             officeRep.rep_groups = Array.from(repMap.values());
            
//             // Calculate office rep total (should match existing total_amt)
//             officeRep.total_amt = officeRep.rep_groups.reduce((sum, group) => sum + group.rep_total, 0);
//         }
//     }
// });


this.service.getAdvtOfficerBriefly1(req).subscribe((data) => {
    this.advtOfficierbrieflyFormBeans = data;
    this.advtOfficierbrieflyTotal = 0;

    if (this.advtOfficierbrieflyFormBeans != null) {
        // Process each office representative
        for (let officeRep of this.advtOfficierbrieflyFormBeans) {
            // Group records by rep_name
            const repMap = new Map();
            
            if (officeRep.rep_data && officeRep.rep_data.length > 0) {
                for (let record of officeRep.rep_data) {
                    const repName = record.rep_name;
                    
                    if (!repMap.has(repName)) {
                        repMap.set(repName, {
                            rep_name: repName,
                            records: [],
                            rep_total: 0
                        });
                    }
                    
                    repMap.get(repName).records.push(record);
                    repMap.get(repName).rep_total += parseFloat(record.rcv_amt) || 0;
                    
                    // Add to grand total
                    this.advtOfficierbrieflyTotal += parseFloat(record.rcv_amt) || 0;
                }
                
                // Convert map to array for template
                officeRep.rep_groups = Array.from(repMap.values());
                
                // Format rep totals to 2 decimal places
                officeRep.rep_groups.forEach(group => {
                    group.rep_total = parseFloat(group.rep_total.toFixed(2));
                });
                
                // Calculate office rep total
                officeRep.total_amt = officeRep.rep_groups.reduce((sum, group) => sum + group.rep_total, 0);
                officeRep.total_amt = parseFloat(officeRep.total_amt.toFixed(2));
            } else {
                officeRep.rep_groups = [];
                officeRep.total_amt = 0;
            }
        }
    }
    
    // Force change detection to complete before print is available
    setTimeout(() => {
        console.log('Data processing complete');
    }, 100);
});


 }


//  exportExcel(fileName: string): void {
//     console.log('exportExcel called with:', fileName);
    
//     let element = document.getElementById('print-section1');
//     if (!element) {
//       console.error('Element with ID print-section1 not found');
//       return;
//     }
    
//     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
//     const wb: XLSX.WorkBook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
//     XLSX.writeFile(wb, fileName + '.xlsx');
//   }


 exportExcel(fileName): void {
  console.log('Export function called with fileName:', fileName);
  
  let element = document.getElementById('print-section');
  console.log('Element found:', element);
  
  if (!element) {
    console.error('Element with ID "print-section" not found in DOM');
    return;
  }
  
  try {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    console.log('Worksheet created:', ws);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    XLSX.writeFile(wb, fileName + '.xlsx');
    console.log('File should be downloaded');
  } catch (error) {
    console.error('Error during export:', error);
  }
}


// In your component TypeScript file
printWithDelay() {
  // Show loading indicator if needed
  setTimeout(() => {
    const printButton = document.getElementById('print-button');
    if (printButton) {
      printButton.click();
    }
  }, 500);
}
 
}
